import type { ApiError } from '@_/api-contracts/common.ts';
import type { ApiPaginatedResponse } from '@_/types';
import { isDefinedError, ORPCError } from '@orpc/client';

export function isApiError(error: unknown): error is ApiError {
  return isDefinedError(error) || error instanceof ORPCError;
}

export async function fetchAllPages<TData>(
  fetchPage: (pagination: { nextCursor: string | null }) => Promise<ApiPaginatedResponse<TData[]>>
): Promise<TData[]> {
  const data: TData[] = [];

  let nextCursor: string | null = null;
  do {
    const resp = await fetchPage({ nextCursor });
    data.push(...resp.data);
    nextCursor = resp.pagination.nextCursor;
  } while (nextCursor);

  return data;
}
